import Handler from '@/core/domain/usecase/handler';

const getVisibleEquipmentsByTruckDriverIDRepository = (axios) => async (id) => {
    try {
        const response = await axios.get(`truck-driver/${id}/equipment`)
        return response.data
    } catch (err) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default getVisibleEquipmentsByTruckDriverIDRepository